
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as indexkIEbRaXbSPuW0J4wRlqApYEFdbEy0aMfHr8BvuPzTZMMeta } from "/app/pages/[slug]/index.vue?macro=true";
import { default as login4Mr5HfTEfOXidvTclwQjDJgZRsYDgmjOaJcTRdIJhjUMeta } from "/app/pages/[slug]/login.vue?macro=true";
import { default as entrance_45ZJSHIFP9UuhyrmnIzaGhhqB79i6a4CmqQC_45cuF6ar0Meta } from "/app/pages/[slug]/entrance.vue?macro=true";
import { default as dashboardwL8lSzqV42otDzrz540_45mBwwLXldIks_45f3TvUlUa4MEMeta } from "/app/pages/[slug]/dashboard.vue?macro=true";
import { default as vectorize6wu9_1QzWyyU4ifRvSC0GQghGnG0Y67C_UfOOQZCaRsMeta } from "/app/pages/[slug]/vectorize.vue?macro=true";
import { default as _91id_93NCLJdOtffd8cm7oUDir6HP79l7CYdEkhuoMFDm9ma90Meta } from "/app/pages/[slug]/logos/[id].vue?macro=true";
import { default as indexFHPLAHVTxPdM3j5KLPJk2ua08rOIFVqrP3rZ2lsYVGEMeta } from "/app/pages/[slug]/logos/index.vue?macro=true";
import { default as indexE8uH9G_45Zhh_45HzectmwR259R4E1WNsaSdzAeLvvDjG6MMeta } from "/app/pages/[slug]/products/index.vue?macro=true";
import { default as indexFIcavroJOpNt8np12A8_45epwI46Dir8h4ER5bHbFSBfMMeta } from "/app/pages/[slug]/customers/index.vue?macro=true";
import { default as raster_45analyzergZN1KxlORn7mt3knBTt3mqaSpIUC3nHkyLtm6ybm6a4Meta } from "/app/pages/[slug]/raster-analyzer.vue?macro=true";
import { default as product_45size_45scalesUi0h4ooLoR19UZSvUoZ2xp6ycX_45puWset_45vE2ZN7R0wMeta } from "/app/pages/[slug]/product-size-scales.vue?macro=true";
import { default as indexdP4RMy_45_ykKulRd45LeNlxzBsNuX42eTKYZm3XRkCt8Meta } from "/app/pages/[slug]/customers/[id]/index.vue?macro=true";
import { default as colorsg2lzEtMOYZWlbPBBQuhirqmf6gWcjutuw0gdPQOKxXoMeta } from "/app/pages/[slug]/customers/[id]/colors.vue?macro=true";
import { default as _91token_932fpvyZghOyq3XKn922Nv2OVg231_4cfX8dae9VjqnvAMeta } from "/app/pages/[slug]/reset-password/[token].vue?macro=true";
import { default as _91id_93705PonyIQf20nbc7XdV5iGhRVx_lZ5g3NDE2wfIaUKgMeta } from "/app/pages/[slug]/customers/[customer]/logos/[id].vue?macro=true";
import { default as index2cvRRckaw8Bh7oVrHbos9wUXB0oP5z9lrhOHzsM4ThYMeta } from "/app/pages/[slug]/customers/[customer]/logos/index.vue?macro=true";
import { default as favorite_45variantshP0i1LCz1IbNMSg0WQzZ5BV_Nv0Ut3t3K9YIF4smTaMMeta } from "/app/pages/[slug]/customers/[id]/favorite-variants.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "slug",
    path: "/:slug()",
    component: () => import("/app/pages/[slug]/index.vue")
  },
  {
    name: "slug-login",
    path: "/:slug()/login",
    meta: login4Mr5HfTEfOXidvTclwQjDJgZRsYDgmjOaJcTRdIJhjUMeta || {},
    component: () => import("/app/pages/[slug]/login.vue")
  },
  {
    name: "slug-entrance",
    path: "/:slug()/entrance",
    meta: entrance_45ZJSHIFP9UuhyrmnIzaGhhqB79i6a4CmqQC_45cuF6ar0Meta || {},
    component: () => import("/app/pages/[slug]/entrance.vue")
  },
  {
    name: "slug-dashboard",
    path: "/:slug()/dashboard",
    component: () => import("/app/pages/[slug]/dashboard.vue")
  },
  {
    name: "slug-vectorize",
    path: "/:slug()/vectorize",
    meta: vectorize6wu9_1QzWyyU4ifRvSC0GQghGnG0Y67C_UfOOQZCaRsMeta || {},
    component: () => import("/app/pages/[slug]/vectorize.vue")
  },
  {
    name: "slug-logos-id",
    path: "/:slug()/logos/:id()",
    meta: _91id_93NCLJdOtffd8cm7oUDir6HP79l7CYdEkhuoMFDm9ma90Meta || {},
    component: () => import("/app/pages/[slug]/logos/[id].vue")
  },
  {
    name: "slug-logos",
    path: "/:slug()/logos",
    meta: indexFHPLAHVTxPdM3j5KLPJk2ua08rOIFVqrP3rZ2lsYVGEMeta || {},
    component: () => import("/app/pages/[slug]/logos/index.vue")
  },
  {
    name: "slug-products",
    path: "/:slug()/products",
    meta: indexE8uH9G_45Zhh_45HzectmwR259R4E1WNsaSdzAeLvvDjG6MMeta || {},
    component: () => import("/app/pages/[slug]/products/index.vue")
  },
  {
    name: "slug-customers",
    path: "/:slug()/customers",
    meta: indexFIcavroJOpNt8np12A8_45epwI46Dir8h4ER5bHbFSBfMMeta || {},
    component: () => import("/app/pages/[slug]/customers/index.vue")
  },
  {
    name: "slug-raster-analyzer",
    path: "/:slug()/raster-analyzer",
    meta: raster_45analyzergZN1KxlORn7mt3knBTt3mqaSpIUC3nHkyLtm6ybm6a4Meta || {},
    component: () => import("/app/pages/[slug]/raster-analyzer.vue")
  },
  {
    name: "slug-product-size-scales",
    path: "/:slug()/product-size-scales",
    meta: product_45size_45scalesUi0h4ooLoR19UZSvUoZ2xp6ycX_45puWset_45vE2ZN7R0wMeta || {},
    component: () => import("/app/pages/[slug]/product-size-scales.vue")
  },
  {
    name: "slug-customers-id",
    path: "/:slug()/customers/:id()",
    meta: indexdP4RMy_45_ykKulRd45LeNlxzBsNuX42eTKYZm3XRkCt8Meta || {},
    component: () => import("/app/pages/[slug]/customers/[id]/index.vue")
  },
  {
    name: "slug-customers-id-colors",
    path: "/:slug()/customers/:id()/colors",
    meta: colorsg2lzEtMOYZWlbPBBQuhirqmf6gWcjutuw0gdPQOKxXoMeta || {},
    component: () => import("/app/pages/[slug]/customers/[id]/colors.vue")
  },
  {
    name: "slug-reset-password-token",
    path: "/:slug()/reset-password/:token()",
    meta: _91token_932fpvyZghOyq3XKn922Nv2OVg231_4cfX8dae9VjqnvAMeta || {},
    component: () => import("/app/pages/[slug]/reset-password/[token].vue")
  },
  {
    name: "slug-customers-customer-logos-id",
    path: "/:slug()/customers/:customer()/logos/:id()",
    meta: _91id_93705PonyIQf20nbc7XdV5iGhRVx_lZ5g3NDE2wfIaUKgMeta || {},
    component: () => import("/app/pages/[slug]/customers/[customer]/logos/[id].vue")
  },
  {
    name: "slug-customers-customer-logos",
    path: "/:slug()/customers/:customer()/logos",
    meta: index2cvRRckaw8Bh7oVrHbos9wUXB0oP5z9lrhOHzsM4ThYMeta || {},
    component: () => import("/app/pages/[slug]/customers/[customer]/logos/index.vue")
  },
  {
    name: "slug-customers-id-favorite-variants",
    path: "/:slug()/customers/:id()/favorite-variants",
    meta: favorite_45variantshP0i1LCz1IbNMSg0WQzZ5BV_Nv0Ut3t3K9YIF4smTaMMeta || {},
    component: () => import("/app/pages/[slug]/customers/[id]/favorite-variants.vue")
  }
]